export const LANG_KEY = 'lang';

export function getLang<SUPPORTED_LANG extends string>(supportedLanguages: SUPPORTED_LANG[]): SUPPORTED_LANG {
  const defaultLang = supportedLanguages[0];
  if (!defaultLang) {
    throw new Error(`You must specify at least one language in the supportedLanguages property.`);
  }
  if (isInIframe()) {
    return defaultLang;
  }
  const lang: string | null | undefined = localStorage.getItem(LANG_KEY);
  return isSupportedLanguage(lang, supportedLanguages) ? lang : defaultLang;
}

export function setLang<SUPPORTED_LANG extends string>(currentLang: SUPPORTED_LANG) {
  localStorage.setItem(LANG_KEY, currentLang);
}

function isInIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

function isSupportedLanguage<SUPPORTED_LANG extends string>(
  lang: string | undefined | null,
  supportedLanguages: SUPPORTED_LANG[]
): lang is SUPPORTED_LANG {
  return typeof lang === 'string' ? supportedLanguages.includes(lang as SUPPORTED_LANG) : false;
}
